








































































import { Popup, Button, Radio } from '@hb/coffee';
import {
  defineComponent, computed, onMounted,
  PropType, ref,
} from '@vue/composition-api';
import {
  RightPackageTypeEnum, RightSummaryType, LoanCardTypeEnum,
} from '@/api/rights/types';
import { ubtSetupPageButton, ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { ActionTypeEnum } from './popupBService';

export default defineComponent({
  name: 'PopStyleB',
  components: {
    Popup,
    Button,
    Radio,
  },
  props: {
    rightParams: {
      type: Object as PropType<RightSummaryType>,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    /** 协议预览,注入方法，兼容js调用的场景 */
    contractPreview: {
      type: Function as PropType<() => void>,
      default: () => {},
    },
    /** 跳转详情 */
    goDetail: {
      type: Function as PropType<() => void>,
      default: () => {},
    },
  },
  emits: ['goDetail', 'update:modelValue', 'choose', 'previewContract'],
  setup(props: {
    modelValue: boolean;
    rightParams: RightSummaryType;
    contractPreview: () => void;
    goDetail: () => void;
  }, { emit }: {
    emit: (event: string, ...args: unknown[]) => void;
  }) {
    /** 是否展示popup */
    const showPopup = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    /** 协议是否勾选 */
    const checked = ref(false);

    /** 未勾选协议时 需要展示气泡 是否展示提示 */
    const showTips = ref(false);

    /** 是否是臻享会员卡 */
    const isZhenXiangMemberCard = computed((
    ) => props.rightParams.packageType === RightPackageTypeEnum.ZHEN_XIANG_MEMBER_CARD);

    /** 是否是哈享卡 */
    const isHaXiangCard = computed((
    ) => props.rightParams.packageType === RightPackageTypeEnum.CHANNEL_B
    && props.rightParams.loanCardType === LoanCardTypeEnum.YOU_SU_CARD);

    /** 描述文案 */
    const descriptionText = computed((
    ) => {
      if (isZhenXiangMemberCard.value) {
        return '臻享会员';
      }
      if (isHaXiangCard.value) {
        return '哈享权益';
      }

      return '臻享权益';
    });

    const toggleSelect = () => {
      // 切换勾选状态
      checked.value = !checked.value;

      // 点击勾选协议状态埋点
      ubtSetupPageButton('fincance_loan_normalapply_click_RetainPopup_agreementCheck', {
        ...props.rightParams,
        checked: checked.value,
      });

      // 如果勾选了协议，并且此时气泡打开 则隐藏气泡
      if (checked.value && showTips.value) {
        showTips.value = false;
      }
    };

    /** 点击详情 */
    const handleGoDetail = () => {
      // 点击详情埋点
      ubtSetupPageButton('fincance_loan_normalapply_click_RetainPopup_detail_click', {
        ...props.rightParams,
      });

      if (props.goDetail) {
        props.goDetail();
      }
      emit('goDetail');
    };

    /** 协议预览 */
    const previewContract = async () => {
      // 点击预览协议埋点
      ubtSetupPageButton('fincance_loan_normalapply_click_RetainPopup_agreement', {
        ...props.rightParams,
      });
      if (props.contractPreview) {
        props.contractPreview();
      }
      emit('previewContract');
    };

    /** 点击确定 */
    const handleConfirm = () => {
      // 点击同意协议并提交埋点
      ubtSetupPageButton('fincance_loan_normalapply_click_RetainPopup_BottomButton', {
        ...props.rightParams,
        buttonName: ActionTypeEnum.AGREE,
        checked: checked.value,
      });
      if (!checked.value) {
        showTips.value = true;
        return;
      }
      emit('choose', true, ActionTypeEnum.AGREE);
    };

    /** 点击放弃 */
    const handleReject = () => {
      // 点击放弃特权埋点
      ubtSetupPageButton('fincance_loan_normalapply_click_RetainPopup_BottomButton', {
        ...props.rightParams,
        buttonName: ActionTypeEnum.REJECT,
      });
      emit('choose', false, ActionTypeEnum.REJECT);
    };

    onMounted(() => {
      // 曝光埋点
      ubtSetupModuleExpose('fincance_loan_normalapply_click_RetainPopup_expose', {
        ...props.rightParams,
      });
    });

    return {
      showPopup,
      handleGoDetail,
      previewContract,
      handleConfirm,
      handleReject,
      checked,
      toggleSelect,
      isZhenXiangMemberCard,
      isHaXiangCard,
      descriptionText,
      showTips,
    };
  },
});
